/** Shown when a cardholder name is rejected for being nothing but digits */
export const NUMERIC_ONLY_NAME_ERROR = "Cardholder name must include at least one letter";

/**
 * Whether a cardholder name is nothing but digits once separators are dropped.
 *
 * Card numbers get typed into the name field both bare and separated, so "4111111111111111",
 * "4111 1111 1111 1111", "4111-1111-1111-1111" and "4111.1111.1111.1111" all qualify. A name
 * that merely contains a digit ("Jane Smith 2nd") does not.
 */
export const isNumericOnlyName = (name: string) => {
  const digitsOnly = name.replace(/[\s.-]/g, "");
  return digitsOnly.length > 0 && /^\d+$/.test(digitsOnly);
};
